import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { API_URL } from '../../Actions/Config'
import OwlCarousel from "react-owl-carousel"
import DatePicker from "react-datepicker";
import AOS from "aos";
import Header from '../Common/Header'
import Footer from '../Common/Footer'
import Helmet from '../Common/Helmet'
import TourListing from "../Common/TourListing"
import { getRentCarDetails } from "../../Actions/TourDetailsAction"
import { handleBooking } from "../../Actions/CheckoutAction"
import { tourFb, tourTw, tourLn } from "../../Images"
import "aos/dist/aos.css";
import "../../css/mainUpdate.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "react-datepicker/dist/react-datepicker.css";

const mapStateToProps = (state) => {
    return {
        tourDetailsReducer: state.TourDetailsReducer,
        CheckoutReducer: state.CheckoutReducer
    }
}

const mapDispatchToProps = dispatch => ({
    getRentCarDetails: (name) => dispatch(getRentCarDetails(name)),
    handleBooking: (data, vehicle) => dispatch(handleBooking(data, vehicle))
});


function getURL(permalink) {
    var url = ""
    url = "/transport/" + permalink
    return url
}

function getImageURL(url, type = 0) {
    var image = ""

    switch (type) {
        case 0:
            image = API_URL + "/" + url
            break;

        default:
            break;
    }

    return image
}

class RentCarDetails extends Component {

    constructor(props) {
        super(props);
        const { peram } = this.props.match.params;
        this.state = {
            start_date: "",
            end_date: "",
            price: 0
        }
        this.props.getRentCarDetails(peram)
    }

    componentDidMount() {
        const savedState = sessionStorage.getItem("transportState");
        if (savedState) {
            const state = JSON.parse(savedState);

            if (state.start_date) {
                state.start_date = new Date(state.start_date);
                state.end_date = new Date(state.end_date);
            }
            this.setState(state);
        }
    }

    handleDateChange = (value, name) => {
        let start_date = this.state.start_date;
        let end_date = this.state.end_date;

        if (name === "start_date") {
            start_date = value;
            end_date = end_date < value ? value : end_date

        } else if (name === "end_date") {
            end_date = value;
        }

        this.setState({
            start_date,
            end_date,
        }, () => {
            const diffTime = Math.abs(end_date - start_date);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
            if (start_date != "") {
                this.setState({
                    price: (diffDays + 1) * this.props.tourDetailsReducer.transport.cost_per_day
                })
            }
        });
    }

    handleBooking = () => {
        const { from, to } = this.state
        if (from == "" || to == "") {
            return false
        }

        sessionStorage.setItem(
            "transportState",
            JSON.stringify(this.state)
        );
        this.props.handleBooking({
            start_date: this.state.start_date.toLocaleDateString('en-GB'),
            end_date: this.state.end_date.toLocaleDateString('en-GB'),
            price: this.state.price
        }, this.props.tourDetailsReducer.transport)

        setTimeout(() => {
            this.props.history.push("/transport/confirm/reserve")
        }, 1000);
    }

    render() {

        const { transport } = this.props.tourDetailsReducer;
        var state = this.state

        return <Fragment>
            {/* {this.props.CheckoutReducer.redirect ? <Redirect to="/transport/confirm/reserve"></Redirect> : null} */}
            <Header home={false} />
            <Helmet
                title={"Tour List"}
                description={"Listing"}
            />
            <div className='tour-details'>
                {transport != null ?
                    <div id='main-container' class="transport-page">

                        <div className="page-title">
                            <div className="container title-cont">
                                <div className="row">
                                    <div className="col-lg-12 title-inner tour-details-breadcrumb">
                                        <div className="breadcrumb-links">
                                            <a href="/">Home</a>
                                            <span className="sep"></span>
                                            <a>Packages </a>
                                        </div>
                                        <h1>{transport.name} </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="contentwrap">
                            <div className="introwrap">
                                <div className="tour-content-wrap">
                                    <div className='container'>
                                        <div className='row'>
                                            <div class="col-lg-4 col-sm-4 col-xs-6 col-po-12">
                                                <div class="car-det" >
                                                    <img src={getImageURL(transport.package_thumbnail)} width="262" height="139" />
                                                    <div class="pack-name pack-name-det">
                                                        <h5>Vehicle Name</h5>
                                                        <p>{transport.vehicle_type.type}</p>
                                                    </div>
                                                    <div class="car-lis-det pack-name-det">
                                                        <img src={getImageURL("assets/website/images/man.png")} width="16" height="17" />
                                                        <div>
                                                            <h5>Number of People</h5>
                                                            <p>{transport.vehicle_type.max_passengers} People</p>
                                                        </div>
                                                    </div>
                                                    <div class="car-lis-det mis-allo pack-name-det">
                                                        <img src={getImageURL("assets/website/images/mileage.png")} width="21" height="19" />
                                                        <div>
                                                            <h5>Mileage Allocation</h5>
                                                            <p>{transport.allocated_mileage} KM</p>
                                                        </div>
                                                    </div>
                                                    <div class="car-lis-det mis-allo pack-name-det">
                                                        <img src={getImageURL("assets/website/images/doller.png")} width="18" height="19" />
                                                        <div>
                                                            <h5>Cost Per Day</h5>
                                                            <p>$ {transport.cost_per_day}</p>
                                                        </div>
                                                    </div>
                                                    <span class="right-dth"></span>
                                                </div>

                                            </div>
                                            <div class="col-lg-8 col-sm-8 col-xs-6 col-po-12">
                                                <div class="car-die">
                                                    <img src={getImageURL("assets/website/images/your-selection.png")} class="trns-img" />
                                                    <p dangerouslySetInnerHTML={{ __html: transport.conditions }} />
                                                </div>
                                            </div>
                                            <div class="col-lg-12 rent-book">
                                                <div class="summery col-po-12">
                                                    <h2>Book Now</h2>
                                                    <p>Rent a Car package calculation will be number of days x rate per day</p>

                                                    <div style={{ width: 300, paddingBottom: 50 }} class="date input-group start_transport_date ">

                                                        <DatePicker
                                                            selected={state.start_date}
                                                            onChange={(date) => this.handleDateChange(date, "start_date")}
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            placeholderText="Start Date"
                                                            minDate={new Date}
                                                        />
                                                    </div>

                                                    <div style={{ width: 300, paddingBottom: 50 }} class="date input-group end_transport_date">

                                                        <DatePicker
                                                            selected={state.end_date}
                                                            onChange={(date) => this.handleDateChange(date, "end_date")}
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            placeholderText="End Date"
                                                            minDate={new Date}
                                                        />
                                                    </div>

                                                </div>

                                                <div class="car-prz col-po-12">
                                                    <p style={{ fontFamily: "circular-std-bold!important" }}>Total</p>
                                                    <h1 style={{ fontFamily: "circular-std-bold!important" }}>USD &nbsp;<span id="total-price">${Number(state.price).toFixed(2)}</span> </h1>

                                                    <button onClick={this.handleBooking} type="submit" class="button  btn-blue pull-right btn-arrow-next btn-lg btn-block  trans_book">Book Now
                                                        <span class="glyphicon glyphicon-chevron-right"> </span></button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null}
            </div>
            <Footer hyperLink={true} />
        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(RentCarDetails);